module.exports = __webpack_public_path__ + "img/labels-3-d-mobile@2x.d487cff6.webp";